'use client'

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { Button } from '@/components/Button'

export default function SpecialistDialog ({ open, onClose, specialist }) {
  return (
    <Dialog open={open} onClose={onClose} className='relative z-10'>
      <DialogBackdrop
        transition
        className='fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in'
      />

      <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
        <div className='flex min-h-full items-end justify-center p-6 text-center sm:items-center sm:p-0'>
          <DialogPanel
            transition
            className='relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[762px] sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95'
          >

            <div className=''>
              <div className='md:flex md:gap-5'>
                {specialist.Media?.Image?.Url && (
                  <figure className='max-w-[320px] md:max-w-[280px] max-md:mx-auto max-md:mb-6'>
                    <img
                      src={specialist.Media?.Image?.Url || '/find-a-specialist-default.png'}
                      alt={specialist.Media?.Image?.AltText || `${specialist.Name} profile picture`}
                      className='w-full aspect-square rounded-lg object-cover'
                      onError={(e) => {
                        e.target.src = '/find-a-specialist-default.png'
                      }}
                    />
                  </figure>
                )}
                <div className='md:mt-8'>
                  {specialist.Name && (
                    <DialogTitle as='h3' className='text-xl font-extrabold mb-2 leading-[1.2] tracking-tight'>
                      {specialist.Name}
                    </DialogTitle>
                  )}
                  <div data-spacer />
                  {specialist.Role && (
                    <p className='text-base font-semibold'>
                      {specialist.Role}
                    </p>
                  )}
                  {specialist.PhoneNumber && (
                    <a
                      href={`tel:${specialist.PhoneNumber}`}
                      className='text-xs font-extrabold'
                    >
                      {specialist.PhoneNumber}
                    </a>
                  )}
                </div>
              </div>
              <div className='mt-6'>
                <div className='flex flex-col gap-2'>
                  <div className='_rte' dangerouslySetInnerHTML={{ __html: specialist.AboutSpecialist }} />
                  <div className='sm:flex sm:justify-center mt-3'>
                    <Button onClick={() => onClose()} variant='primary' mobile='responsive'>
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </div>

          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
